import React from 'react'
import { useForm, Link } from '@inertiajs/react'
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
} from '@mui/material'
import ManagementLayout from '@/components/layouts/ManagementLayout'

interface Props {
  account: {
    name: string
  }
}

export default function AccountsNew({ account }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    name: account.name || '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/accounts')
  }

  return (
    <ManagementLayout>
      <Box sx={{ maxWidth: 672, mx: 'auto' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" fontWeight={600}>
            Create Account
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Create a new account to organize your backends, virtual buckets, and credentials.
          </Typography>
        </Box>

        <Paper sx={{ p: 3 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Name"
              fullWidth
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
              error={!!errors.name}
              helperText={errors.name || 'The name of your account or organization.'}
              placeholder="My Organization"
              autoFocus
            />

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button component={Link} href="/accounts">
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={processing}>
                Create Account
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </ManagementLayout>
  )
}
